import type { Ref } from 'react'
import s from './ReportHtmlFrame.module.css'

export type ReportHtmlFrameProps = {
  /** Легаси-HTML отчёта из 1С, как пришёл с бэка. Произвольная вёрстка, доверия нет. */
  html: string
  /** Доступное имя рамки: без него скринридер читает «frame». Готовый `t(…)`. */
  title: string
  ref?: Ref<HTMLIFrameElement>
}

/**
 * Безопасный показ HTML-отчёта из 1С. Фрагмент — чужая легаси-разметка произвольной вёрстки,
 * поэтому он не вставляется в общий DOM (`dangerouslySetInnerHTML`), а изолируется нативным
 * `<iframe srcDoc sandbox>`: пустой `sandbox` включает все ограничения и, главное, НЕ содержит
 * `allow-scripts` — скрипты внутри не исполняются, доступа к родительскому документу и cookie нет.
 * Белый список тегов (как в `entities/news`) здесь не годится: отчёт — полноразмерный документ с
 * таблицами и собственными стилями, фильтровать его потегово значило бы ломать вёрстку; песочница
 * надёжнее и короче. Высота ограничена, вёрстка прокручивается внутри рамки.
 */
export function ReportHtmlFrame({ html, title, ref }: ReportHtmlFrameProps) {
  return <iframe ref={ref} className={s.frame} sandbox="" srcDoc={html} title={title} />
}
